import { ASSETS } from "assets";
import FlexBox from "lib/components/common/flex-box";
import LoadingBox from "lib/components/common/loading-box";
import SimpleButton from "lib/components/common/simple-button";
import SimpleCard from "lib/components/common/simple-card";
import SimpleModal from "lib/components/common/simple-modal";
import DashboardLayout from "lib/components/layouts/dashboard";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import usePractitioner from "lib/hooks/usePractitioner";
import { openUrlInSameTab } from "lib/utils/util";
import { FC } from "react";
import { Col, Image, Row } from "react-bootstrap";
import { PiSealWarningBold } from "react-icons/pi";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";

const breadcrumbItems: BreadcrumbItem[] = [
  {
    label: "Subscriptions",
    path: PAGE_ROUTES.PRACTITIONER.Subscription,
  },
  {
    label: "Failure",
    path: PAGE_ROUTES.PRACTITIONER.SubscriptionFailure,
  },
];

interface PractitionerCheckoutFailedPageProps {}

const PractitionerCheckoutFailedPage: FC<
  PractitionerCheckoutFailedPageProps
> = ({}) => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const {
    getCheckoutSession,
    loading: practitionerLoading,
    error: practitionerError,
  } = usePractitioner();

  const handleRetryPayment = () => {
    let transactionId = searchParams.get("transactionId");
    const altTransactionId = location.state?.transactionId;

    if (!transactionId) {
      if (altTransactionId) {
        transactionId = altTransactionId;
      } else {
        toast.error("Transaction ID is missing. Please contact support.");
        return;
      }
    }

    getCheckoutSession(transactionId, (session) => {
      if (session?.url) {
        openUrlInSameTab(session.url);
      } else {
        toast.error("Failed to retrieve payment session. Please try again.");
      }
    });
  };

  return (
    <DashboardLayout breadcrumbItems={breadcrumbItems}>
      <Row className="justify-content-center">
        <Col sm="6">
          <SimpleCard error={practitionerError}>
            <FlexBox
              direction="column"
              justifyContent="center"
              alignItems="center"
            >
              <PiSealWarningBold size={64} color="orange" />
              <h3 className="text-center">Oops! Transaction failed.</h3>
            </FlexBox>
            <br />
            <p className="text-center">
              Please try again by clicking the button below. If the issue
              persists, please contact support.
            </p>
            <FlexBox justifyContent="center" alignItems="center">
              <SimpleButton onClick={handleRetryPayment}>Pay now</SimpleButton>
            </FlexBox>
          </SimpleCard>
        </Col>
      </Row>
      <SimpleModal open={practitionerLoading} close={() => {}} size="sm">
        <LoadingBox message="Fetching session details ..." />
      </SimpleModal>
    </DashboardLayout>
  );
};

export default PractitionerCheckoutFailedPage;
